export default __webpack_public_path__ + "static/media/arrow-scroll.fe5a4f13.svg";